"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Carousel_component_exports = {};
__export(Carousel_component_exports, {
  Carousel: () => Carousel,
  default: () => Carousel_component_default
});
module.exports = __toCommonJS(Carousel_component_exports);
var import_react = __toESM(require("react"));
var import_debounce = __toESM(require("lodash/debounce"));
var import_useEventListener = require("../../../utils/useEventListener/useEventListener.hook");
var import_Helpers = require("../../../utils/Helpers");
var import_react_i18next = require("react-i18next");
var import_Carousel = require("./Carousel.styled");
var import_BreakLabel = require("./BreakLabel.component");
var import_types = require("./types");
var import_i18n = __toESM(require("../../../i18n"));
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
var _excluded = ["slideOptions", "currentSlide", "darkMode", "prevButtonAriaLabel", "nexButtonAriaLabel", "breakLabelAriaLabel", "shuffle", "variant", "visibleSlides"], _excluded2 = ["label"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var Carousel = function Carousel2(_ref) {
  var _ref$slideOptions = _ref.slideOptions, slideOptions = _ref$slideOptions === void 0 ? [] : _ref$slideOptions, _ref$currentSlide = _ref.currentSlide, currentSlide = _ref$currentSlide === void 0 ? 1 : _ref$currentSlide, _ref$darkMode = _ref.darkMode, darkMode = _ref$darkMode === void 0 ? false : _ref$darkMode, prevButtonAriaLabel = _ref.prevButtonAriaLabel, nexButtonAriaLabel = _ref.nexButtonAriaLabel, breakLabelAriaLabel = _ref.breakLabelAriaLabel, _ref$shuffle = _ref.shuffle, shuffle = _ref$shuffle === void 0 ? false : _ref$shuffle, _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? import_types.variants.large : _ref$variant, _ref$visibleSlides = _ref.visibleSlides, visibleSlides = _ref$visibleSlides === void 0 ? 7 : _ref$visibleSlides, props = _objectWithoutProperties(_ref, _excluded);
  var iconSize = 32;
  var maxVisibleSlidesForMobile = 4;
  var maxVisibleSlidesForDesktop = 7;
  var paginationRef = (0, import_react.useRef)(null);
  var _useState = (0, import_react.useState)(currentSlide), _useState2 = _slicedToArray(_useState, 2), activeSlide = _useState2[0], setActiveSlide = _useState2[1];
  var _useState3 = (0, import_react.useState)([]), _useState4 = _slicedToArray(_useState3, 2), allSlides = _useState4[0], setAllSlides = _useState4[1];
  var _useState5 = (0, import_react.useState)(false), _useState6 = _slicedToArray(_useState5, 2), focusActiveSlide = _useState6[0], setFocusActiveSlide = _useState6[1];
  var _useState7 = (0, import_react.useState)(visibleSlides), _useState8 = _slicedToArray(_useState7, 2), visibleSlidesCount = _useState8[0], setVisibleSlidesCount = _useState8[1];
  var _useState9 = (0, import_react.useState)([]), _useState10 = _slicedToArray(_useState9, 2), visibleSlidesArray = _useState10[0], setVisibleSlidesArray = _useState10[1];
  var _useState11 = (0, import_react.useState)({
    left: [],
    right: []
  }), _useState12 = _slicedToArray(_useState11, 2), hiddenSlidesArray = _useState12[0], setHiddenSlidesArray = _useState12[1];
  var _matchMedia = (0, import_Helpers.matchMedia)(), medium = _matchMedia.medium;
  var checkMedia = function checkMedia2() {
    if (visibleSlides < 3) {
      setVisibleSlidesCount(3);
    } else if (medium.matches) {
      if (visibleSlides > maxVisibleSlidesForDesktop) {
        setVisibleSlidesCount(maxVisibleSlidesForDesktop);
      } else {
        setVisibleSlidesCount(visibleSlides);
      }
    } else if (visibleSlides > maxVisibleSlidesForMobile) {
      setVisibleSlidesCount(maxVisibleSlidesForMobile);
    } else {
      setVisibleSlidesCount(visibleSlides);
    }
  };
  (0, import_react.useEffect)(checkMedia, [visibleSlides]);
  (0, import_useEventListener.useEventListener)("resize", (0, import_debounce.default)(checkMedia, 200));
  var setVisibleSlidesAndBreakLabel = function setVisibleSlidesAndBreakLabel2(currentActive, allSlideOptions, visibleSlideOptions) {
    if (visibleSlideOptions < allSlideOptions.length) {
      if (currentActive < visibleSlideOptions) {
        setVisibleSlidesArray(allSlideOptions.slice(0, visibleSlideOptions - 1));
        setHiddenSlidesArray({
          left: [],
          right: allSlideOptions.slice(visibleSlideOptions - 1)
        });
      } else if (currentActive > allSlideOptions.length - visibleSlideOptions + 1) {
        setVisibleSlidesArray(allSlideOptions.slice(allSlideOptions.length - visibleSlideOptions + 1));
        setHiddenSlidesArray({
          left: allSlideOptions.slice(0, allSlideOptions.length - visibleSlideOptions + 1),
          right: []
        });
      } else {
        setVisibleSlidesArray(allSlideOptions.slice(currentActive - 1, currentActive + visibleSlideOptions - 3));
        setHiddenSlidesArray({
          left: allSlideOptions.slice(0, currentActive - 1),
          right: allSlideOptions.slice(currentActive + visibleSlideOptions - 3, allSlideOptions.length)
        });
      }
    } else {
      setVisibleSlidesArray(allSlideOptions);
      setHiddenSlidesArray({
        left: [],
        right: []
      });
    }
    setActiveSlide(currentActive);
  };
  (0, import_react.useEffect)(function() {
    var allSlideOptions = slideOptions.map(function(slide, index) {
      return _objectSpread({
        uuId: index + 1
      }, slide);
    });
    setAllSlides(allSlideOptions);
    var currentActiveSlide = currentSlide <= allSlideOptions.length && currentSlide > 0 ? currentSlide : 1;
    setVisibleSlidesAndBreakLabel(currentActiveSlide, allSlideOptions, visibleSlidesCount);
  }, [slideOptions, currentSlide, visibleSlidesCount]);
  (0, import_react.useEffect)(function() {
    if (focusActiveSlide) {
      var focusableEls = (0, import_Helpers.getFocusableEls)(paginationRef.current);
      focusableEls.forEach(function(el) {
        if (el.getAttribute("aria-current") === "true") {
          el.focus();
        }
      });
      setFocusActiveSlide(false);
    }
  }, [focusActiveSlide]);
  var onBreakLabelOptionClick = function onBreakLabelOptionClick2(currentActive) {
    setVisibleSlidesAndBreakLabel(currentActive, allSlides, visibleSlidesCount);
    setFocusActiveSlide(true);
    if (props.onSlideChange) {
      props.onSlideChange(currentActive, "breakLabelOptionClick");
    }
  };
  var handlePreviousClick = function handlePreviousClick2(currentActive) {
    var updatedActive = currentActive - 1;
    if (currentActive === 1) {
      updatedActive = shuffle ? allSlides.length : currentActive;
    }
    if (updatedActive !== currentActive) {
      var firstVisibleSlide = visibleSlidesArray[0];
      if (visibleSlidesCount < allSlides.length && currentActive === firstVisibleSlide.uuId) {
        if (updatedActive === allSlides.length) {
          setVisibleSlidesArray(allSlides.slice(allSlides.length - visibleSlidesCount + 1));
          setHiddenSlidesArray({
            left: allSlides.slice(0, allSlides.length - visibleSlidesCount + 1),
            right: []
          });
        } else if (updatedActive <= 2) {
          setVisibleSlidesArray(allSlides.slice(0, visibleSlidesCount - 1));
          setHiddenSlidesArray({
            left: [],
            right: allSlides.slice(visibleSlidesCount - 1)
          });
        } else {
          setVisibleSlidesArray(allSlides.slice(updatedActive - 1, updatedActive + visibleSlidesCount - 3));
          setHiddenSlidesArray({
            left: allSlides.slice(0, updatedActive - 1),
            right: allSlides.slice(updatedActive + visibleSlidesCount - 3)
          });
        }
      }
      if (updatedActive === 1 && !shuffle) {
        var _focusableEls$;
        var focusableEls = (0, import_Helpers.getFocusableEls)(paginationRef.current);
        (_focusableEls$ = focusableEls[1]) === null || _focusableEls$ === void 0 || _focusableEls$.focus();
      }
      setActiveSlide(updatedActive);
      if (props.onSlideChange) {
        props.onSlideChange(updatedActive, "previousButtonClick");
      }
    }
  };
  var handleNextClick = function handleNextClick2(currentActive) {
    var updatedActive = currentActive + 1;
    if (currentActive === allSlides.length) {
      updatedActive = shuffle ? 1 : currentActive;
    }
    if (updatedActive !== currentActive) {
      var lastVisibleSlide = visibleSlidesArray[visibleSlidesArray.length - 1];
      if (visibleSlidesCount < allSlides.length && currentActive === lastVisibleSlide.uuId) {
        if (updatedActive === 1) {
          setVisibleSlidesArray(allSlides.slice(0, visibleSlidesCount - 1));
          setHiddenSlidesArray({
            left: [],
            right: allSlides.slice(visibleSlidesCount - 1)
          });
        } else if (updatedActive >= allSlides.length - 1) {
          setVisibleSlidesArray(allSlides.slice(allSlides.length - visibleSlidesCount + 1));
          setHiddenSlidesArray({
            left: allSlides.slice(0, allSlides.length - visibleSlidesCount + 1),
            right: []
          });
        } else {
          setVisibleSlidesArray(allSlides.slice(updatedActive - visibleSlidesCount + 2, updatedActive));
          setHiddenSlidesArray({
            left: allSlides.slice(0, updatedActive - visibleSlidesCount + 2),
            right: allSlides.slice(updatedActive)
          });
        }
      }
      if (updatedActive === allSlides.length && !shuffle) {
        var _focusableEls;
        var focusableEls = (0, import_Helpers.getFocusableEls)(paginationRef.current);
        (_focusableEls = focusableEls[focusableEls.length - 2]) === null || _focusableEls === void 0 || _focusableEls.focus();
      }
      setActiveSlide(updatedActive);
      if (props.onSlideChange) {
        props.onSlideChange(updatedActive, "nextButtonClick");
      }
    }
  };
  var handleSlideClick = function handleSlideClick2(id) {
    setActiveSlide(id);
    if (props.onSlideChange) {
      props.onSlideChange(id, "slideClick");
    }
  };
  var _useTranslation = (0, import_react_i18next.useTranslation)(), t = _useTranslation.t;
  var slideOptionsNumberPrefixTranslated = props.slideOptionsNumberPrefix || "".concat(t("dp_core_toCapitalFirstLetter_anyKey", {
    value: t("base_glossary_item_one")
  }));
  return /* @__PURE__ */ import_react.default.createElement(import_react_i18next.I18nextProvider, {
    i18n: import_i18n.default
  }, /* @__PURE__ */ import_react.default.createElement(import_Carousel.StyledContainer, {
    ref: paginationRef,
    "data-testid": "paginationContainer",
    width: props.width,
    variant,
    tabIndex: -1
  }, /* @__PURE__ */ import_react.default.createElement(import_Carousel.StyledIconButton, {
    disabled: !shuffle && activeSlide === 1 || activeSlide > allSlides.length,
    "data-testid": "previous-arrow",
    icon: variant === import_types.variants.smallVertical ? "chevron-up" : "chevron-back",
    iconSize,
    "aria-label": prevButtonAriaLabel || t("base_action_previous"),
    onClick: function onClick() {
      return handlePreviousClick(activeSlide);
    },
    "aria-controls": props.slidesContainerId,
    darkMode,
    color: props.arrowsColor,
    dataDpAnalyticsId: props.prevButtonDataDpAnalyticsId
  }), /* @__PURE__ */ import_react.default.createElement(import_Carousel.StyledSlidesContainer, {
    variant
  }, hiddenSlidesArray.left.length > 0 && /* @__PURE__ */ import_react.default.createElement("li", null, /* @__PURE__ */ import_react.default.createElement(import_BreakLabel.BreakLabel, {
    "data-testid": "left-break-label",
    options: hiddenSlidesArray.left,
    onItemClick: onBreakLabelOptionClick,
    variant,
    darkMode,
    listItemNumberPrefix: slideOptionsNumberPrefixTranslated,
    breakLabelAriaLabel: breakLabelAriaLabel || t("base_constant_moreItems")
  })), visibleSlidesArray.map(function(_ref2) {
    var label = _ref2.label, options = _objectWithoutProperties(_ref2, _excluded2);
    return /* @__PURE__ */ import_react.default.createElement("li", {
      className: "tile",
      key: options.uuId
    }, /* @__PURE__ */ import_react.default.createElement(import_Carousel.StyledSlide, _extends({}, options, {
      "data-testid": "slide",
      "aria-label": label || "".concat(slideOptionsNumberPrefixTranslated, " ").concat(options.uuId),
      "aria-current": options.uuId === activeSlide,
      isCurrentSlide: options.uuId === activeSlide,
      onClick: function onClick() {
        return handleSlideClick(options.uuId);
      },
      darkMode,
      variant,
      "data-dp-analytics-id": "".concat(props.slideButtonDataDpAnalyticsId ? "".concat(props.slideButtonDataDpAnalyticsId, "-") : "").concat(options.uuId)
    })));
  }), hiddenSlidesArray.right.length > 0 && /* @__PURE__ */ import_react.default.createElement("li", null, /* @__PURE__ */ import_react.default.createElement(import_BreakLabel.BreakLabel, {
    "data-testid": "right-break-label",
    options: hiddenSlidesArray.right,
    onItemClick: onBreakLabelOptionClick,
    breakLabelAriaLabel: breakLabelAriaLabel || t("base_constant_moreItems"),
    variant,
    darkMode,
    listItemNumberPrefix: slideOptionsNumberPrefixTranslated
  }))), /* @__PURE__ */ import_react.default.createElement(import_Carousel.StyledIconButton, {
    disabled: !shuffle && activeSlide === allSlides.length || activeSlide > allSlides.length,
    "data-testid": "next-arrow",
    icon: variant === import_types.variants.smallVertical ? "chevron-down" : "chevron-front",
    iconSize,
    "aria-label": nexButtonAriaLabel || t("base_action_next"),
    onClick: function onClick() {
      return handleNextClick(activeSlide);
    },
    "aria-controls": props.slidesContainerId,
    darkMode,
    color: props.arrowsColor,
    dataDpAnalyticsId: props.nextButtonDataDpAnalyticsId
  })));
};
var Carousel_component_default = Carousel;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Carousel
});
//# sourceMappingURL=Carousel.component.js.map